import ApolloClient from 'apollo-client';
import { notify } from 'legacy-packages/ft-cb';
import {
  getCbSession,
  redirectToLogin,
  refreshAccessToken,
} from 'legacy/src/components/auth/utils';
import { LC_CONSTANTS } from 'legacy/src/components/impersonating/utils/constants';

const getConfig = ({ accessTokenKey, refreshTokenKey, expiresKey }) => ({
  use: [
    {
      applyMiddleware(req, next) {
        /**
         * Get authentication token from localStorage.
         * @todo move this to a service.
         */
        getCbSession();
        const accessToken = window.localStorage.getItem(accessTokenKey);
        if (!accessToken) {
          return;
        }

        if (!req.options.headers) {
          req.options.headers = {
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${accessToken}`,
          };
        }
        const expiresValueOf = parseInt(
          window.localStorage.getItem(expiresKey),
          10,
        );
        // if our token is about to expire, we'll get a new one
        if (new Date() > new Date(expiresValueOf - 5000)) {
          refreshAccessToken({
            refreshTokenKey,
            accessTokenKey,
            expiresKey,
          }).then((response) => {
            req.options.headers.Authorization = `Bearer ${response.data.access_token}`;
            next();
          });
        } else {
          next();
        }
      },
    },
  ],
  useAfter: [
    {
      applyAfterware(res, next) {
        if (res.response.status === 422) {
          redirectToLogin();
        } else if (res.response.status >= 500) {
          notify.error(
            'Error processing the request. Please, contact the support team.',
          );
        }
        next();
        //need to return res or we will get an error
        return res;
      },
    },
  ],
});

const config = getConfig({
  accessTokenKey: LC_CONSTANTS.AT,
  refreshTokenKey: LC_CONSTANTS.RT,
  expiresKey: LC_CONSTANTS.EXP,
});
const impersonatorConfig = getConfig({
  accessTokenKey: LC_CONSTANTS.IAT,
  refreshTokenKey: LC_CONSTANTS.IRT,
  expiresKey: LC_CONSTANTS.IEXP,
});

const bootstrapApollo = (
  networkInterface,
  fragmentMatcher,
  isImpersonating = false,
) => {
  networkInterface
    .use(isImpersonating ? impersonatorConfig.use : config.use)
    .useAfter(config.useAfter);

  return new ApolloClient({
    networkInterface,
    fragmentMatcher,
    shouldBatch: true,
  });
};

export default bootstrapApollo;
